import React, { useState } from "react";
import { MdDelete } from "react-icons/md";

import { useRemoveQuestionImageMutation } from "../../slices/questionImageApiSlice";
import QuestionImageUpload from "./QuestionImageUpload";

const QuestionImageActions = ({ questionId }) => {
  const [removeQuestionImage, { isLoading }] = useRemoveQuestionImageMutation();

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleRemove = async () => {
    try {
      await removeQuestionImage(questionId).unwrap();
      setOpenDeleteDialog(false);
    } catch (error) {
      console.error("Remove image error:", error);
    }
  };

  return (
    <>
      <div className="flex items-center gap-3">
        {/* Replace Image */}
        <QuestionImageUpload questionId={questionId} />

        {/* Remove Image */}
        <button
          type="button"
          disabled={isLoading}
          onClick={() => setOpenDeleteDialog(true)}
          className="inline-flex items-center gap-2 rounded-lg border border-red-500 px-4 py-2 text-red-600 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-60 transition"
        >
          {isLoading ? (
            <>
              <svg
                className="h-4 w-4 animate-spin"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                />
              </svg>
              Removing...
            </>
          ) : (
            <>
              <MdDelete className="text-lg" />
              Remove
            </>
          )}
        </button>
      </div>

      {/* Delete Confirmation Modal */}
      {openDeleteDialog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
            <h2 className="text-xl font-semibold text-gray-800">
              Remove Question Image
            </h2>

            <p className="mt-3 text-gray-600">
              Are you sure you want to remove this image?
            </p>

            <div className="mt-6 flex justify-end gap-3">
              <button
                type="button"
                onClick={() => setOpenDeleteDialog(false)}
                className="rounded-lg border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-100 transition"
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={handleRemove}
                disabled={isLoading}
                className="rounded-lg bg-red-600 px-4 py-2 text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60 transition"
              >
                {isLoading ? "Removing..." : "Remove"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionImageActions;
